function defaultTemplate(body) {
  return `
  <html>
    <head>
    <meta charset="utf-8">
    <title>MARKDOWN to STYLED HTML</title>
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
    <script src="https://use.fontawesome.com/2b0dc300da.js"></script>
    <link href="https://fonts.googleapis.com/css?family=Lato:400,700,900" rel="stylesheet">

    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.5.1/katex.min.css">
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/github-markdown-css/2.2.1/github-markdown.css"/>
      <style>
      body {margin: 0; padding: 0}
      .markdown-body { margin: 15px 30px 30px 30px !important; font-family: 'Lato', sans-serif !important;}
      .markdown-body  table  {
           border-collapse:  collapse;
           text-align:  left;
           width:  100% !important;
           margin-bottom: 20px;
           display: inline-table;
       }

      .markdown-body  table td,  .markdown-body  table th  {
           padding:  3px 10px;
       }
      .markdown-body  table thead th  {
          background: -webkit-gradient( linear,  left top,  left bottom,  color-stop(0.05,  #8C8C8C),  color-stop(1,  #7D7D7D) );
          background: -moz-linear-gradient( center top,  #8C8C8C 5%,  #7D7D7D 100% );
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#8C8C8C',  endColorstr='#7D7D7D');
          background-color: #8C8C8C;
           color: #FFFFFF;
           font-size:  15px;
           font-weight:  bold;
           border-left:  1px solid #A3A3A3;
       }
       .markdown-body  table thead th:first-child  {
           border:  none;
       }
      .markdown-body  table tbody td  {
           color:  #7D7D7D;
           border-left:  1px solid #DBDBDB;
          font-size:  12px;
          font-weight:  normal;
       }
      .markdown-body  table tbody .alt td  {
           background:  #EBEBEB;
           color:  #7D7D7D;
       }
      .markdown-body  table tbody td:first-child  {
           border-left:  none;
       }
      .markdown-body  table tbody tr:last-child td  {
           border-bottom:  none;
       }
      .markdown-body  table tfoot td div  {
           border-top:  1px solid #8C8C8C;
          background:  #EBEBEB;
      }
       .markdown-body  table tfoot td  {
           padding:  0;
           font-size:  12px }
       .markdown-body  table tfoot td div {
           padding:  2px;
       }
      .markdown-body  table tfoot td ul  {
           margin:  0;
           padding: 0;
           list-style:  none;
           text-align:  right;
       }
      .markdown-body  table tfoot  li  {
           display:  inline;
       }
      .markdown-body  table tfoot li a  {
           text-decoration:  none;
           display:  inline-block;
            padding:  2px 8px;
           margin:  1px;
          color:  #F5F5F5;
          border:  1px solid #8C8C8C;
          -webkit-border-radius:  3px;
           -moz-border-radius:  3px;
           border-radius:  3px;
           background: -webkit-gradient( linear,  left top,  left bottom,  color-stop(0.05,  #8C8C8C),  color-stop(1,  #7D7D7D) );
          background: -moz-linear-gradient( center top,  #8C8C8C 5%,  #7D7D7D 100% );
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#8C8C8C',  endColorstr='#7D7D7D');
          background-color: #8C8C8C;
       }
      .markdown-body  table tfoot ul.active,  .markdown-body  table tfoot ul a:hover  {
           text-decoration:  none;
          border-color:  #7D7D7D;
           color:  #F5F5F5;
           background:  none;
           background-color: #8C8C8C;
      }


      .markdown-body  h1,
      .markdown-body  h2,
      .markdown-body  h3,
      .markdown-body  h4,
      .markdown-body  h5 {margin-bottom: 20px; font-weight: 900 !important}
      .markdown-body  img {margin-bottom: 40px;}

      footer {
          background: #eee;
          padding-top: 15px;
          padding-bottom: 15px;
          margin-top: 50px;
          border-top: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          text-align: center;
          font-weight: 900;
          text-transform: uppercase;
          font-family: 'Lato', sans-serif;
           font-size: 12px;
      }



      </style>

    </head>
    <body>
      <div class="markdown-body">
      ${body}
      </div>

      <footer class="footer" style="">
      <p><a href="https://markdown.icjia.cloud">ICJIA Markdown Editor</a>&nbsp;&nbsp;|&nbsp;&nbsp;<i class="fa fa-github" aria-hidden="true"></i>&nbsp;<a href="https://github.com/ICJIA/icjia-markdown">View on Github</a></p>
      </footer>

    </body>
  </html>
  `
}

export {defaultTemplate}



// WEBPACK FOOTER //
// ./src/templates/default.js